import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';
import styles from './Checkbox.css';
import CheckMark from '../Icons/Checkmark';
import slugify from '../../utils/slugify';
import getUniqueId from '../../utils/getUniqueId';

const Checkbox = ({
    label,
    label2,
    labelClassName,
    checked,
    onChange,
    primaryColor,
    className,
    iconClassName,
    type,
    dispatch,
    id = getUniqueId('checkbox'),
    ...props
}) => (<div
    className={cx(styles.container, className)}
>
    <input
        onChange={() => onChange(!checked)}
        type={type}
        id={id}
        {...props}
        onBlur={() => null}
        checked={checked}
        aria-labelledby={`${id}-label`}
    />
    <div
        style={{ borderColor: primaryColor, borderWidth: 2 }}
        className={cx(styles.checkbox, {
            [styles.checked]: checked,
            [styles.radio]: type === 'radio',
        }, iconClassName)}
    >
        <CheckMark />
    </div>
    <label
        id={`${id}-label`}
        className={labelClassName}
        htmlFor={id}
    >
        <div className={styles.label}>{label}</div>
        {label2 ? <div className={styles.label2}>{label2}</div> : null}
    </label>
</div>);


Checkbox.propTypes = {
    label: PropTypes.string,
    label2: PropTypes.string,
    labelClassName: PropTypes.string,
    checked: PropTypes.bool,
    onChange: PropTypes.func,
    primaryColor: PropTypes.string,
    className: PropTypes.string,
    iconClassName: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.string,
    dispatch: PropTypes.func,
};

Checkbox.defaultProps = {
    onChange: () => ({}),
    checked: false,
    type: 'checkbox',
};

const generateId = ({ label, label2 }) => {
    const id = `checkbox-${slugify(label)}`;
    if (label2) {
        return `${id}-${slugify(label2)}`;
    }
    return id;
};

export default connect(({ theme: { primaryColor } }, props) => ({
    primaryColor,
    id: props.id || generateId(props),
}))(Checkbox);



// WEBPACK FOOTER //
// ./src/client/Components/Checkbox/Checkbox.js